import { FilterType } from 'features/FilterItems/types'

export const actions = {
  setHomeFilters: (homeFilters: FilterType) => ({ type: 'FILTERS__SET_HOME_FILTERS', filters: { homeFilters } } as const),
  setListingFilters: (listingFilters: FilterType) => ({ type: 'FILTERS__SET_LISTING_FILTERS', filters: { listingFilters } } as const),
  setNetworkFilters: (networkFilters: FilterType) => ({ type: 'FILTERS__SET_NETWORK_FILTERS', filters: { networkFilters } } as const),
  setNetworkModalFilters: (networkModalFilters: FilterType) => ({ type: 'FILTERS__SET_NETWORK_MODAL_FILTERS', filters: { networkModalFilters } } as const)
}
